import React from 'react';
import { Popup } from 'react-leaflet';
import { SlopeInfo } from '../../../../../../../../core/types/types';
import { slopeDirectionTextSetter } from '../../../../../../components/MeasuringTool/functions/slopeDirectionTextSetter';
import { theme } from '../../../../../../../../core/theme/theme';

interface SlopeServicePopupProps {
    mapCenter: any;
    polygonDirectionalSlopesInfo: SlopeInfo[];
    mainSlopeInfo: SlopeInfo;
}
const SlopeServicePopup: React.FC<SlopeServicePopupProps> = ({ mapCenter, polygonDirectionalSlopesInfo, mainSlopeInfo }) => {
    return (
        <Popup maxWidth={1000}>
            <>
                <div style={{ marginBottom: 10 }}>
                    <div style={{ display: 'flex', flexDirection: 'row-reverse', gap: 3 }}>
                        <div style={{ margin: 'auto', marginBottom: 5, textAlign: 'center', fontWeight: 'bold' }}>
                            {' '}
                            <div
                                style={{
                                    margin: 'auto',
                                    marginBottom: 3,
                                    width: 10,
                                    height: 10,
                                    backgroundColor: theme.colors.main_slope_color,
                                    fontSize: 25,
                                    fontWeight: 800,
                                    borderRadius: '100px',
                                }}
                            />
                            شیب اصلی{' '}
                        </div>
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row-reverse',
                            justifyContent: 'space-evenly',
                            gap: 10,
                            textAlign: 'center',
                        }}
                    >
                        <div style={{ marginBottom: '5px' }}>
                            :طول شیب (متر)
                            <div style={{ fontWeight: 'bold' }}>{mainSlopeInfo.slopePointsDistance.toFixed(2)}</div>
                        </div>
                        <div style={{ marginBottom: '5px' }}>
                            :درصد شیب
                            <div style={{ fontWeight: 'bold' }}>
                                {Math.abs(mainSlopeInfo.slopePercentage).toFixed(2)}%
                            </div>{' '}
                        </div>
                        <div style={{ marginBottom: '5px' }}>
                            :زاویه شیب
                            <div style={{ fontWeight: 'bold' }}>{Math.abs(mainSlopeInfo.slopeAngle).toFixed(2)}°</div>
                        </div>
                        <div style={{ marginBottom: '5px' }}>
                            :جهت شیب{' '}
                            <div style={{ fontWeight: 'bold' }}>
                                {slopeDirectionTextSetter(mainSlopeInfo.slopeDirection.direction)}
                            </div>
                        </div>
                        <div>
                            :زاویه جهت{' '}
                            <div style={{ fontWeight: 'bold' }}>{mainSlopeInfo.slopeDirection.degree.toFixed(2)}°</div>
                        </div>
                    </div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row-reverse', gap: '40px' }}>
                    {polygonDirectionalSlopesInfo.map((slope, index: number) => {
                        if (slope.slopePercentage > 0 && slope.slopeAngle > 0)
                            return (
                                <div style={{ textAlign: 'center' }}>
                                    <div style={{ marginBottom: '8px', color: slope.color, textDecoration: 'underline' }}>
                                        <div
                                            style={{
                                                margin: 'auto',
                                                width: 10,
                                                height: 10,
                                                backgroundColor: slope.color,
                                                fontSize: 25,
                                                fontWeight: 800,
                                                borderRadius: '100px',
                                                color: slope.color,
                                            }}
                                        />
                                    </div>
                                    <div style={{ marginBottom: '5px' }}>
                                        :طول شیب (متر)
                                        <div style={{ fontWeight: 'bold' }}>{slope.slopePointsDistance.toFixed(2)}</div>
                                    </div>
                                    <div style={{ marginBottom: '5px' }}>
                                        :درصد شیب
                                        <div style={{ fontWeight: 'bold' }}>
                                            {Math.abs(slope.slopePercentage).toFixed(2)}%
                                        </div>{' '}
                                    </div>
                                    <div style={{ marginBottom: '5px' }}>
                                        :زاویه شیب
                                        <div style={{ fontWeight: 'bold' }}>{Math.abs(slope.slopeAngle).toFixed(2)}°</div>
                                    </div>
                                    <div style={{ marginBottom: '5px' }}>
                                        :جهت شیب{' '}
                                        <div style={{ fontWeight: 'bold' }}>
                                            {slopeDirectionTextSetter(slope.slopeDirection.direction)}
                                        </div>
                                    </div>
                                    <div>
                                        :زاویه جهت{' '}
                                        <div style={{ fontWeight: 'bold' }}>{slope.slopeDirection.degree.toFixed(2)}°</div>
                                    </div>
                                </div>
                            );
                    })}
                </div>
            </>
        </Popup>
    );
};

export default SlopeServicePopup;
